import mod from "-!./APicture.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./APicture.js?vue&type=script&lang=js&external"